import { Link } from 'react-router-dom'
import { FileText, Github, Twitter, Mail } from 'lucide-react'

const footerNavigation = {
  main: [
    { name: 'Generator', href: '/generator' },
    { name: 'Verification', href: '/verification' },
    { name: 'What is llm.txt?', href: '/what-is-llm-txt' },
    { name: 'Benefits', href: '/benefits' },
    { name: 'AI SEO Guide', href: '/ai-seo-best-practices' },
    { name: 'Implementation', href: '/implementation-guide' },
  ],
  resources: [
    { name: 'Blog', href: '/blog' },
    { name: 'Documentation', href: '/what-is-llm-txt' },
    { name: 'Best Practices', href: '/ai-seo-best-practices' },
    { name: 'Support', href: '/contact' },
  ],
  social: [
    {
      name: 'GitHub',
      href: '#',
      icon: Github,
    },
    {
      name: 'Twitter',
      href: '#',
      icon: Twitter,
    },
    {
      name: 'Email',
      href: 'mailto:hello@llm-txt-generator.com',
      icon: Mail,
    },
  ],
}

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="py-12 lg:py-16">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="space-y-8 xl:col-span-1">
              <Link to="/" className="flex items-center space-x-2">
                <div className="flex items-center justify-center w-10 h-10 bg-gradient-primary rounded-lg">
                  <FileText className="h-6 w-6 text-white" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xl font-bold font-heading text-gray-900">
                    llm.txt Generator
                  </span>
                  <span className="text-sm text-gray-600">
                    AI SEO Made Simple
                  </span>
                </div>
              </Link>
              <p className="text-gray-600 text-sm max-w-md">
                The free, easy-to-use tool for creating llm.txt files that help AI tools like ChatGPT, Claude, and Gemini better understand your website content.
              </p>
              <div className="flex space-x-6">
                {footerNavigation.social.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-gray-400 hover:text-primary-600 transition-colors duration-200"
                  >
                    <span className="sr-only">{item.name}</span>
                    <item.icon className="h-6 w-6" aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>
            <div className="mt-12 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
                    Tools
                  </h3>
                  <ul role="list" className="mt-4 space-y-4">
                    {footerNavigation.main.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.href}
                          className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-12 md:mt-0">
                  <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
                    Resources
                  </h3>
                  <ul role="list" className="mt-4 space-y-4">
                    {footerNavigation.resources.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.href}
                          className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 py-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <p className="text-sm text-gray-600">
              &copy; 2024 llm.txt Generator. Made with ❤️ for the AI SEO community.
            </p>
            <div className="mt-4 md:mt-0">
              <p className="text-sm text-gray-600">
                Free forever. Open source.{' '}
                <a
                  href="https://llmtext.net"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 hover:text-primary-700 transition-colors duration-200"
                >
                  Learn about llm.txt
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
